import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Link } from "react-router-dom";
import { site } from "../mock";
import { useContent } from "../context/ContentContext";

const links = [
  { label: "About", href: "/#about" },
  { label: "Services", href: "/#services" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Team", href: "/#team" },
  { label: "Before & After", href: "/before-after", route: true },
  { label: "Locations", href: "/#locations" },
  { label: "Contact", href: "/#contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { content } = useContent();
  const bookUrl = content.settings.bookUrl;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const renderLink = (l, cls) =>
    l.route ? (
      <Link key={l.href} to={l.href} onClick={() => setOpen(false)} className={cls}>
        {l.label}
      </Link>
    ) : (
      <a key={l.href} href={l.href} onClick={() => setOpen(false)} className={cls}>
        {l.label}
      </a>
    );

  return (
    <>
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0C0C0C]/95 backdrop-blur-md py-3 shadow-lg shadow-black/20" : "bg-[#0C0C0C]/40 backdrop-blur-sm py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group">
          <span className="font-serif-display text-2xl md:text-3xl text-[#C6A15B] leading-none">
            {site.name}
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) =>
            renderLink(
              l,
              "nav-link text-[12px] tracking-[0.16em] uppercase text-[#EDE7DA] hover:text-[#C6A15B]"
            )
          )}
          <a
            href={bookUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="text-[12px] tracking-[0.16em] uppercase border border-[#C6A15B] text-[#C6A15B] px-5 py-2.5 hover:bg-[#C6A15B] hover:text-[#0C0C0C] transition-colors duration-300"
          >
            Book Now
          </a>
        </nav>

        <button
          className="lg:hidden text-[#EDE7DA]"
          onClick={() => setOpen(true)}
          aria-label="Open menu"
        >
          <Menu size={26} />
        </button>
      </div>
      </header>

      {/* Mobile drawer (sibling of header so it fills the viewport, not the blurred header) */}
      <div
        className={`fixed inset-0 z-[60] lg:hidden flex flex-col transition-opacity duration-300 ${
          open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        style={{ backgroundColor: "#0C0C0C" }}
      >
        <div className="flex justify-between items-center px-6 py-5 border-b border-[#242424]">
          <span className="font-serif-display text-2xl text-[#C6A15B]">{site.name}</span>
          <button
            onClick={() => setOpen(false)}
            aria-label="Close menu"
            className="text-[#F7F2EA] p-1"
          >
            <X size={28} />
          </button>
        </div>

        <nav className="flex flex-col flex-1 overflow-y-auto px-6 py-4">
          {links.map((l) =>
            l.route ? (
              <Link
                key={l.href}
                to={l.href}
                onClick={() => setOpen(false)}
                className="block w-full text-center py-5 border-b border-[#242424] font-serif-display text-2xl text-[#F7F2EA] active:text-[#C6A15B]"
              >
                {l.label}
              </Link>
            ) : (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="block w-full text-center py-5 border-b border-[#242424] font-serif-display text-2xl text-[#F7F2EA] active:text-[#C6A15B]"
              >
                {l.label}
              </a>
            )
          )}
          <a
            href={bookUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setOpen(false)}
            className="mt-8 mb-6 text-center text-sm tracking-[0.2em] uppercase bg-[#C6A15B] text-[#0C0C0C] px-8 py-4 font-medium"
          >
            Book Now
          </a>
        </nav>
      </div>
    </>
  );
}
